import * as $runtime from "../runtime.js";
import * as Control$dBind from "../Control.Bind/index.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dEuclideanRing from "../Data.EuclideanRing/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dList from "../Data.List/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dRatio from "../Data.Ratio/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Data$dUnfoldable from "../Data.Unfoldable/index.js";
import * as Restaumatic$dMenu$dV2$dPackaging from "../Restaumatic.Menu.V2.Packaging/index.js";
const notTooLargeContainers = dictOrd => map => Data$dMap$dInternal.filterWithKey({
  compare: v => v1 => dictOrd.compare(v._1.details)(v1._1.details),
  Eq0: () => {
    const $0 = dictOrd.Eq0();
    return {eq: v => v1 => $0.eq(v._1.details)(v1._1.details)};
  }
})(v => {
  const $0 = v._1.capacity;
  return containeds => {
    const $1 = dictOrd.Eq0();
    return !(
      Data$dRatio.ordRatio(Data$dOrd.ordInt)(Data$dEuclideanRing.euclideanRingInt).compare($0)(Data$dFoldable.foldlArray(vol => contained => Data$dRatio.semiringRatio(Data$dOrd.ordInt)(Data$dEuclideanRing.euclideanRingInt).add(vol)(contained.allowedContainers.length === 0
        ? Data$dRatio.semiringRatio(Data$dOrd.ordInt)(Data$dEuclideanRing.euclideanRingInt).zero
        : contained.volume))(Data$dRatio.semiringRatio(Data$dOrd.ordInt)(Data$dEuclideanRing.euclideanRingInt).zero)(containeds)).tag === "GT"
    ) || (() => {
      const $2 = Data$dArray.index(Data$dArray.sortWith(Data$dRatio.ordRatio(Data$dOrd.ordInt)(Data$dEuclideanRing.euclideanRingInt))(v$1 => v$1._1.capacity)(Data$dList.toUnfoldable(Data$dUnfoldable.unfoldableArray)(Data$dMap$dInternal.keys(Data$dMap$dInternal.functorMap.map(v$1 => {})(map)))))(0);
      if ($2.tag === "Just") { return $1.eq(v._1.details)($2._1._1.details); }
      return false;
    })();
  };
})(map);
const largestContainerWithContainedsFittingIn = dictOrd => map => {
  const v = Data$dArray.index(Data$dArray.sortBy(v1 => {
    const $0 = v1._1._1.capacity;
    return v2 => Data$dRatio.ordRatio(Data$dOrd.ordInt)(Data$dEuclideanRing.euclideanRingInt).compare(v2._1._1.capacity)($0);
  })(Data$dMap$dInternal.toUnfoldable(Data$dUnfoldable.unfoldableArray)(map)))(0);
  if (v.tag === "Nothing") { return Data$dMaybe.Nothing; }
  if (v.tag === "Just") {
    const $0 = v._1._1._1.capacity;
    return Data$dMaybe.$Maybe(
      "Just",
      Data$dTuple.$Tuple(
        v._1._1,
        Data$dFoldable.foldlArray(v2 => {
          const $1 = v2._2;
          const $2 = v2._1;
          return v3 => {
            const newVol = Data$dRatio.semiringRatio(Data$dOrd.ordInt)(Data$dEuclideanRing.euclideanRingInt).add($2)(v3.volume);
            if (!(Data$dRatio.ordRatio(Data$dOrd.ordInt)(Data$dEuclideanRing.euclideanRingInt).compare(newVol)($0).tag === "GT")) {
              return Data$dTuple.$Tuple(newVol, Data$dSemigroup.concatArray([v3])($1));
            }
            return v2;
          };
        })(Data$dTuple.$Tuple(Data$dRatio.semiringRatio(Data$dOrd.ordInt)(Data$dEuclideanRing.euclideanRingInt).zero, []))(v._1._2)._2
      )
    );
  }
  $runtime.fail();
};
const containedsByEligibleContainers = dictOrd => containeds => Data$dFoldable.foldlArray(Data$dMap$dInternal.unionWith({
  compare: v => v1 => dictOrd.compare(v._1.details)(v1._1.details),
  Eq0: () => {
    const $0 = dictOrd.Eq0();
    return {eq: v => v1 => $0.eq(v._1.details)(v1._1.details)};
  }
})(Data$dSemigroup.concatArray))(Data$dMap$dInternal.Leaf)(Control$dBind.arrayBind(containeds)(contained => Data$dFunctor.arrayMap(a => Data$dMap$dInternal.$$$Map(
  "Two",
  Data$dMap$dInternal.Leaf,
  a,
  [contained],
  Data$dMap$dInternal.Leaf
))((() => {
  const $0 = contained.volume;
  return Data$dArray.filter(v1 => !(Data$dRatio.ordRatio(Data$dOrd.ordInt)(Data$dEuclideanRing.euclideanRingInt).compare(v1._1.capacity)($0).tag === "LT"))(contained.allowedContainers);
})())));
const minNumberOfContainersHeuristic = dictOrd => containeds => {
  const v = largestContainerWithContainedsFittingIn(dictOrd)(containedsByEligibleContainers(dictOrd)(containeds));
  if (v.tag === "Nothing") { return []; }
  if (v.tag === "Just") {
    return Data$dSemigroup.concatArray([v._1])(minNumberOfContainersHeuristic(dictOrd)(Data$dFoldable.foldrArray(Data$dArray.delete(Restaumatic$dMenu$dV2$dPackaging.eqContained(dictOrd.Eq0())))(containeds)(v._1._2)));
  }
  $runtime.fail();
};
export {containedsByEligibleContainers, largestContainerWithContainedsFittingIn, minNumberOfContainersHeuristic, notTooLargeContainers};
